<template>
  <side-panel-inner :headerTitle="`${editMode ? 'Replace' : 'Add'} File`" v-if="documentReady">
    <div v-if="documentReady">
      <p>To upload a new file, simply click the button below and choose a file to upload. The file will be automatically uploaded and added to the library.</p>
      <form>
        <file-upload
          name=":name"
          :docType="docType"
          @uploaded="onFileUploaded"
          :bypassDuplicate="false"
          v-validate="{required: true}"
          data-vv-as="file upload"
          :error="error"
          v-model="file"
        />
      </form>

      <message type="success" v-if="uploaded">
        <p>The file has been successfully uploaded</p>
      </message>
    </div>
    <loading v-else></loading>
  </side-panel-inner>

  <side-panel-inner v-else>
    <loading></loading>
  </side-panel-inner>
</template>

<script>
import { mapState } from "vuex";
import PdfPreview from "@/components/PdfPreview";
import Dropdown from "@/components/Dropdown";
import DropdownAction from "@/components/DropdownAction";
import Callout from "@/components/Containers/BaseCallout";
import DownloadWarning from "@/components/DownloadWarning";
import filesApi from "@/api/files";
import FileUpload from "@/components/FileUpload";

export default {
  name: "file-preview",

  data() {
    return {
      documentReady: false,
      fileReady: false,
      downloadPercent: 0,
      hideWarning: false,
      fileSrc: null,
      isIE: false,
      fileLink: null,
      file: {},
      docType: {
        single: "file",
        plural: "files"
      },
      uploaded: false
    };
  },

  beforeMount() {
    const vm = this;
    const fileId = this.$route.params.id;

    // so that the background isn't empty...
    if (!this.$store.state.files.files) {
      this.$store.dispatch("files/list");
    }

    if (this.editMode) {
      this.$store.dispatch("files/read", fileId).then(() => {
        vm.documentReady = true;
        vm.fileReady = true;
      });
    }
  },

  mounted() {
    if (this.editMode) {
      this.getFile();
    } else {
      this.documentReady = true;
    }
  },

  computed: {
    ...mapState("files", ["uploadedFile"]),
    editMode() {
      return this.$route.params.id ? true : false;
    },

    hasPermissionToUpdate() {
      if (!this.$store.state.auth.currentUser.privileges) {
        this.$store.dispatch("auth/listCurrentUser").then(resp => {
          return this.$store.state.auth.currentUser.privileges[
            `add_${this.$route.params.docType}`
          ];
        });
      } else {
        return this.$store.state.auth.currentUser.privileges[
          `add_${this.$route.params.docType}`
        ];
      }
    }
  },

  methods: {
    onFileUploaded(upload) {
      // TODO: When a file is uploaded, it is automatically saved in the database, so all we need to do here really is notify the user
      if (!upload.isDuplicate){
      this.$store.dispatch("notifications/create", {
        body: "The file has been uploaded",
        type: "success"
      });
      }
    },
    getFile() {
      const vm = this;
      filesApi.read(this.$route.params.id).then(file => {
        this.fileLink = file.link;
        this.file = file;

        filesApi.readLink(file.link).then(response => {
          this.setFileData(response.data);
        });
      });
    },
    setFileData(blob) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        this.isIE = true;
        return;
      }

      const vm = this;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        vm.fileSrc = base64data;
      };
    },
    onClickDownload() {
      this.$store.dispatch("files/read", this.$route.params.id).then(resp => {
        this.$store.dispatch("files/download", resp);
      });
    },
    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("files/delete", this.$route.params.id)
            .then(resp => {
              vm.$store.dispatch("notifications/create", {
                body: "The file has been deleted",
                type: "success"
              });
              this.$store.dispatch("CLOSE_PANEL", "AdminFilesIndexPage");
            })
            .catch(err => {
              vm.$store.dispatch("notifications/create", {
                body: `There was a problem - ${err}`,
                type: "danger"
              });
            });
        }
      });
    }
  },

  components: {
    FileUpload
  }
};
</script>
